/**
 * Copyright IBM Corp. 2022, 2026
 */

import { Badge } from '../../components/badge'
import s from './style.module.css'

type Products =
	| 'hashicorp'
	| 'boundary'
	| 'consul'
	| 'nomad'
	| 'packer'
	| 'terraform'
	| 'vault'
	| 'vagrant'
	| 'waypoint'

interface ProductBadgeProps {
	productName: Products
	hasDot?: boolean
}

const ProductBadge = ({ productName, hasDot }: ProductBadgeProps) => {
	const finalProductName = productName.replace('hashicorp', 'HashiCorp')

	const productBrand =
		finalProductName === 'HashiCorp cloud platform' ? 'hashicorp' : productName

	return (
		<Badge
			className={s.badge}
			text={finalProductName}
			{...(hasDot && {
				icon: 'dot',
				iconColor: `var(--mds-color-${productBrand}-brand)`,
			})}
		/>
	)
}

ProductBadge.displayName = 'ProductBadge'

export type { ProductBadgeProps }
export { ProductBadge }
